import './MyLibrary.scss';
import CardWithoutBottomHeader from '../TeacherStudentClassroomCards/CardWithoutBottomHeader';
import images from '../../assets/images';
import { useLazyQuery } from '@apollo/client';
import { GET_CHAT_INDICATION, GET_CLASSROOM_UPDATES, GET_MYLIBRARY_FILES } from '../../pages/TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import ToasterWithMessage from '../toaster';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import { useEffect, useState } from 'react';
import { setSelectedLibraryId } from '../../redux/slices/dashboardSlice';
import Loader from '../Loader/Loader';
import CardWithBottomHeader from '../TeacherStudentClassroomCards/CardWithBottomHeader';
import { CLASSROOM_S3_PATH, SCHOOL_ADMIN, STUDENT_ROLE, VIRTUAL } from '../../utils/constants';
import BottomAdvertisement from '../BottomAdvertisement/BottomAdvertisement';
import { EbookNode, GetChatCountResponse, GetClassroomUpdatesResponse, GetClassroomUpdatesVariables, LibraryNode } from '../../pages/TeacherStudentClassroom/types/TeacherStudentClassroom';
import { setChatTabIndication, setIndication, setTabIndication } from '../../redux/slices/indication';
import { getScreenDimensions } from '../../utils/helper';


interface libraryNodesType{
  lType: string;
  lAvatarUrl: string;
  lId: string;
  lTypeInfo: string;
}

interface MyLibraryProps{
  adimage ? : string[]
  imageLoader? :boolean;
}
const MyLibrary:React.FC<MyLibraryProps> = ({adimage,imageLoader}) => {
  const dispatch = useAppDispatch();
  const role = useAppSelector((state) => state.auth.role);
    const {EbookImage,ImagesCardImage, PodcastImage, SyndicatedVideoImage} = images;
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const [mylibraries,setMyLibraries] = useState<libraryNodesType[]>();
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const {error} = ToasterWithMessage();
    const [librayNodes, setLibrayNodes] = useState<LibraryNode[]>([]);
    const [ebookNodes, setEbookNodes] = useState<EbookNode[]>([]);
    const schoolType = useAppSelector((state) => state.auth.schoolType);


      // to get my library files
    const [ getLibraryFiles, {loading} ] = useLazyQuery(GET_MYLIBRARY_FILES, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        const libraries = data?.allMylibraries?.nodes;
        const sortedItems = [...libraries].sort((a, b) => a.lType.localeCompare(b.lType));
        setMyLibraries(sortedItems);
      },
      onError: (err) => {
        error(err?.message);
      }
    });

    const libraryOne = mylibraries?.[0];
    const libraryTwo = mylibraries?.[1];
    const libraryThree = mylibraries?.[2];
    const libraryFour = mylibraries?.[3];

    useEffect(() => {
      if(role !== SCHOOL_ADMIN){
        getLibraryFiles({
          variables: {
            cId: selectedClassRoomId 
          }
        });
      }
        dispatch(setSelectedLibraryId({selectedLibraryId: ''}));
    },[])

    //indication for quiz, assignments, mylibrary
   const [getClassRoomUpdates] = useLazyQuery<
   GetClassroomUpdatesResponse,
   GetClassroomUpdatesVariables
 >(GET_CLASSROOM_UPDATES,{
   fetchPolicy:'network-only',
   onCompleted: (data) => {
    const { quiz, assignments, mylibrary, ebooks } = data.getClassroomUpdates;
    const quizCount = quiz.totalCount;
    const assignmentCount = assignments.totalCount;
    const myLibrayCount = mylibrary.totalCount
    const ebooksCount = ebooks.totalCount;
    const libaryNodes = mylibrary.nodes
    const ebookNodes = ebooks.nodes

    setLibrayNodes(libaryNodes)
    setEbookNodes(ebookNodes)
  
    const hasQuiz = quizCount > 0;
    const hasAssignment = assignmentCount > 0;
    const hasMylibrary =  myLibrayCount > 0;
    const hasEbooks = ebooksCount > 0;
  
    // Set tab indication based on either quiz or assignment presence
    dispatch(setTabIndication(hasQuiz || hasAssignment || hasMylibrary || hasEbooks));
  
    // Update quiz and assignment indications
    dispatch(setIndication({ 
      quiz: hasQuiz, 
      assignment: hasAssignment,
      myLibray: hasMylibrary || hasEbooks
    }));
  },
  
   onError: (err) =>{
     console.log(err.message)
   }
 });
 

 //indication for chat
 const [getIndicationChat] = useLazyQuery<
   GetChatCountResponse,
   GetClassroomUpdatesVariables
 >(GET_CHAT_INDICATION, {
   fetchPolicy: "network-only",
   onCompleted: (data) => {
     const chatCount = data.getAllChatCount;
     const hasChat = chatCount > 0;
     dispatch(setChatTabIndication(hasChat))
     dispatch(
       setIndication({
         chat: hasChat,
       })
     );
   },
   onError: (err) => {
     console.log(err.message);
   },
 });

    useEffect(()=>{
    if(role === STUDENT_ROLE && selectedClassRoomId){
      getClassRoomUpdates({
        variables :{
          cId : selectedClassRoomId ?? ''
        }
      })
      // if(schoolType !== VIRTUAL){
      getIndicationChat({
       variables: {
         cId: selectedClassRoomId ?? "",
       },
     });
    // }
    }
    },[getClassRoomUpdates, getIndicationChat, selectedClassRoomId])
 
 const isActive = (lId : string) => {
    return librayNodes.some(node => node.lId === lId)  
 }

  return (
    <div className='myLibraryMainContainer' style={{height: loading ? '100%' : ''}}>
      {
        loading || imageLoader ? <Loader bottom='90px'/>
        :
       ( 
        <>
       <div className='cardsContainer'>
            <CardWithoutBottomHeader image={libraryOne?.lAvatarUrl ? baseUrl + CLASSROOM_S3_PATH + libraryOne?.lAvatarUrl : EbookImage} title={libraryOne?.lType ? libraryOne?.lType : 'E-Books'} imageHeight={'44px'} imageWidth={'44px'} navigateLocation={role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks" : role === STUDENT_ROLE ? '/student-classroom/ebooks' : '/teacher-classroom/ebooks'} libraryId={libraryOne?.lId} keyValue={`${libraryOne?.lId}-${libraryOne?.lType}`} sessionActive={false} active={ebookNodes.length > 0 ? true : false}/>
            <CardWithoutBottomHeader image={libraryTwo?.lAvatarUrl ? baseUrl + CLASSROOM_S3_PATH + libraryTwo?.lAvatarUrl : ImagesCardImage} title={libraryTwo?.lType ? libraryTwo?.lType : 'Images'} imageHeight={'44px'} imageWidth={'44px'} navigateLocation={role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/images" : role === STUDENT_ROLE ? '/student-classroom/images' : '/teacher-classroom/images'} libraryId={libraryTwo?.lId} keyValue={`${libraryTwo?.lId}-${libraryTwo?.lType}`} sessionActive={false} active={isActive(libraryTwo?.lId ?? '')}/>
            <CardWithBottomHeader image={libraryThree?.lAvatarUrl ? baseUrl + CLASSROOM_S3_PATH + libraryThree?.lAvatarUrl : PodcastImage} title ={libraryThree?.lType ? libraryThree?.lType : 'Podcast'} bottomHeader={'Powered By Katon Network'} imageHeight={getScreenDimensions()?.isMobileScreen ? '56px' : '46px'} imageWidth={'46px'} libraryId={libraryThree?.lId} paddingBottom={'11px'} navigateLocation={role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/podcast" : role === STUDENT_ROLE ? '/student-classroom/podcast' :'/teacher-classroom/podcast'} keyValue={`${libraryThree?.lId}-${libraryThree?.lType}`} active={isActive(libraryThree?.lId ?? '')}/>
            <CardWithBottomHeader image={libraryFour?.lAvatarUrl ? baseUrl + CLASSROOM_S3_PATH + libraryFour?.lAvatarUrl : SyndicatedVideoImage} title ={libraryFour?.lType ? libraryFour?.lType : 'Syndicated Videos'} bottomHeader={'Powered By Katon Network'} imageHeight={'54px'} imageWidth={'54px'} libraryId={libraryFour?.lId} paddingBottom={'3px'} navigateLocation={role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/videos" : role === STUDENT_ROLE ? '/student-classroom/videos' : '/teacher-classroom/videos'} keyValue={`${libraryFour?.lId}-${libraryFour?.lType}`} active={isActive(libraryFour?.lId ?? '')}/>
        </div>
        {adimage && <BottomAdvertisement adImage={adimage[0]}/>}
        </>
      )
      }
        
    </div>
  )
}

export default MyLibrary;
